import * as loaders from "loaders/legacy/legacy";
export { loaders };
export default loaders;
